/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use VisitorFieldEnum from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export enum VisitorFieldEnum {
  Required = 'required',
  Optional = 'optional',
  Hide = 'hide',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use ScheduleTypeEnum from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export enum ScheduleTypeEnum {
  SpecificDate = 'specific_date',
  CustomDates = 'custom_dates',
  DateRange = 'date_range',
  Repeat = 'repeat',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use IntervalTypeEnum from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export enum IntervalTypeEnum {
  EveryDay = 'every_day',
  EveryWeekday = 'every_weekday',
  Weekly = 'weekly',
  Monthly = 'monthly',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use MonthIntervalTypeEnum from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export enum MonthIntervalTypeEnum {
  OnDate = 'on_date',
  FirstOfDay = 'first_of_day',
  SecondOfDay = 'second_of_day',
  ThirdOfDay = 'third_of_day',
  FourthOfDay = 'fourth_of_day',
  LastOfDay = 'last_of_day',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use VisitorMenuEnum from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export enum VisitorMenuEnum {
  General = 'General',
  Scheduling = 'Scheduling Options',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use ScheduleInAdvanceEnum from constants-visitor-management instead.
 * @see libs/constants/visitor-management
 */
export enum ScheduleInAdvanceEnum {
  One = '1 Month',
  Two = '2 Months',
  Three = '3 Months',
  Four = '4 Months',
  Five = '5 Months',
  Six = '6 Months',
  Seven = '7 Months',
  Eight = '8 Months',
  Nine = '9 Months',
  Ten = '10 Months',
  Eleven = '11 Months',
  Twelve = '12 Months',
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * This array is not exported from constants-visitor-management as it uses IntervalTypeEnum which should be sourced from there.
 * @see libs/constants/visitor-management
 */
export const repeatDropdownItems = [
  {
    label:
      'shared.content.feature.visitorManagement.form.repeatDropdown.everyday',
    value: IntervalTypeEnum.EveryDay,
  },
  {
    label:
      'shared.content.feature.visitorManagement.form.repeatDropdown.everyWeekday',
    value: IntervalTypeEnum.EveryWeekday,
  },
  {
    label:
      'shared.content.feature.visitorManagement.form.repeatDropdown.weekly',
    value: IntervalTypeEnum.Weekly,
  },
  {
    label:
      'shared.content.feature.visitorManagement.form.repeatDropdown.monthly',
    value: IntervalTypeEnum.Monthly,
  },
];
